const LockIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.92285 9.66667H8.40015C7.56007 9.66667 7.13972 9.66667 6.81885 9.83621C6.5366 9.98535 6.3073 10.2231 6.16349 10.5158C6 10.8486 6 11.2845 6 12.1557V16.5113C6 17.3825 6 17.8178 6.16349 18.1506C6.3073 18.4433 6.5366 18.6815 6.81885 18.8306C7.1394 19 7.55927 19 8.3977 19H15.6023C16.4408 19 16.86 19 17.1805 18.8306C17.4628 18.6815 17.6929 18.4433 17.8367 18.1506C18 17.8181 18 17.3834 18 16.5139V12.1532C18 11.2837 18 10.8483 17.8367 10.5158C17.6929 10.2231 17.4628 9.98535 17.1805 9.83621C16.8597 9.66667 16.4402 9.66667 15.6001 9.66667H14.0767M9.92285 9.66667H14.0767M9.92285 9.66667C9.82726 9.66667 9.75 9.58631 9.75 9.48718V7.33333C9.75 6.04467 10.7574 5 12 5C13.2426 5 14.25 6.04467 14.25 7.33333V9.48718C14.25 9.58631 14.1723 9.66667 14.0767 9.66667"
      stroke="#26262B"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default LockIcon;
